/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demo_Refused_WorkspaceInputs */



/**
* | output |
* | --- |
* | "The demo's bot, server and sign-in can't be changed." |
*
* @param {Demo_Refused_WorkspaceInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const demo_refused_workspace = /** @type {((inputs?: Demo_Refused_WorkspaceInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demo_Refused_WorkspaceInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Бота, сервер и вход в демо изменить нельзя.")
	return /** @type {LocalizedString} */ ("The demo's bot, server and sign-in can't be changed.")
});